
let sizeChartSelectorIn = document.getElementById('size-chart-in');
let sizeChartSelectorCm = document.getElementById('size-chart-cm');

if (sizeChartSelectorIn) {
  sizeChartSelectorIn.addEventListener('click', function() {
    if (!sizeChartSelectorIn.classList.contains('active')) {
      sizeChartSelectorIn.classList.toggle('active');
      sizeChartSelectorCm.classList.toggle('active');
    }
  });
}

if (sizeChartSelectorCm) {
  sizeChartSelectorCm.addEventListener('click', function() {
    if (!sizeChartSelectorCm.classList.contains('active')) {
      sizeChartSelectorIn.classList.toggle('active');
      sizeChartSelectorCm.classList.toggle('active');
    }
  });
}

// const urlParams = new URLSearchParams(window.location.search);
// const userIdFromUrl = urlParams.get('smrtft_cmpgn');

// if (userIdFromUrl) {
//   localStorage.setItem('smrtftCmpgn', userIdFromUrl);
//   document.getElementById('promotion-lock').remove();
// }

// const keyToCheck = 'smrtftCmpgn';

// if (localStorage.getItem(keyToCheck) !== null) {
//   const itemValue = localStorage.getItem(keyToCheck);
//   if (itemValue == '100lb-launch') {
//     console.log('promotion unlocked!');
//     document.getElementById('promotion-lock').remove();
//   } 
// } 

// document.addEventListener("DOMContentLoaded", function(event) {
//   const urlParams = new URLSearchParams(window.location.search);
//   const userIdFromUrl = urlParams.get('smrtft_cmpgn');

//   if (userIdFromUrl) {
//     localStorage.setItem('smrtftCmpgn', userIdFromUrl);
//     document.getElementById('promotion-lock').remove();
//   }

//   const keyToCheck = 'smrtftCmpgn';

//   if (localStorage.getItem(keyToCheck) !== null) {
//     const itemValue = localStorage.getItem(keyToCheck);
//     if (itemValue == '100lb-launch') {
//       console.log('promotion unlocked!');
//       document.getElementById('promotion-lock').remove();
//     } 
//   } 
// });

document.addEventListener('variant:add', function(event) {
  let productInfoBlockList = event.target.closest('.product-info');
  let productInfoAddOnVariant = productInfoBlockList.querySelector('#add-on-variant');
  let productInfoQty = productInfoBlockList.querySelector('.product-info__quantity-selector  quantity-selector input')
  if(productInfoAddOnVariant) {
    const formData = {
    'items': [
      {
        'id': productInfoAddOnVariant.value,
        'parent_line_key': event.detail.items[0].key,
        'quantity': productInfoQty.value
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        setTimeout(() => {
          const url = 'https://smrtft.com'
          async function updateCart() {
            try {
              const response = await fetch(url); // Fetch the URL
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              const content = await response.text(); // Get the response text

              const parser = new DOMParser();
              const doc = parser.parseFromString(content, "text/html"); // Parse the HTML

              const newContent = doc.querySelector("#cart-drawer .cart-drawer__line-items line-item"); // Adjust the selector based on the structure of the fetched page

              if (newContent) {
                const lineItem = document.querySelector("#cart-drawer .cart-drawer__line-items line-item");
                lineItem.innerHTML = newContent.innerHTML; // Update the section with new content);
              }
            } catch (error) {
              console.error("Error fetching the product details:", error);
            }
          }

          updateCart();
        }, 500);
        return response.json(); 
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
});

document.addEventListener('cart:change', function(event) {
  let cartItems = event.detail.cart.items;
  if (event.detail.baseEvent == 'line-item:change') {
    let addedItem = event.detail.cart.items_added[0];
    let removedItem = event.detail.cart.items_removed[0];

    if (addedItem) {
      cartItems.forEach((item, index) => {
        let itemParentRelationship = item.parent_relationship;
        if (itemParentRelationship && itemParentRelationship.parent_key == addedItem.view_key) {
          const formData = {
            'id': item.key,
            'quantity': item.quantity + addedItem.quantity
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then(response => {
              return response.json();
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200); 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    } else if (removedItem) {
      cartItems.forEach((item, index) => {
        let itemParentRelationship = item.parent_relationship;
        if (itemParentRelationship && itemParentRelationship.parent_key == removedItem.view_key) {
          const formData = {
            'id': item.key,
            'quantity': item.quantity - removedItem.quantity
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then(response => {
              return response.json();
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200); 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    }
  }
});


// // Example using fetch API in client-side JavaScript
// document.getElementById('subscribeForm').addEventListener('submit', async (event) => {
//   event.preventDefault();

//   const options = {
//     method: 'POST',
//     headers: {accept: 'application/json', 'content-type': 'application/json'},
//     body: JSON.stringify({
//       profiles: [
//         {email: 'george.washington@klaviyo.com'},
//         {phone_number: '+13239169023', sms_consent: true}
//       ]
//     })
//   };

//   fetch('https://a.klaviyo.com/api/v2/list/UD2esu/subscribe?api_key=pk_e789180a86603bc8b22bf3ff54c43ec557', options)
//     .then(res => res.json())
//     .then(res => console.log(res))
//     .catch(err => console.error(err));
//   });